import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findEducations } from "services/EducationService";
import { X_TOTAL_COUNT } from "utils/constants";
import { handleError } from "utils/handleError";
import { EducationContext } from "./EducationContext";
export const EducationList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["education", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const educationContext = useContext(EducationContext);
    const { educations, setEducations } = educationContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(true);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            code: { value: "", matchMode: "ilike" },
            name: { value: "", matchMode: "ilike" },
            description: { value: "", matchMode: "ilike" },
            priority: { value: null, matchMode: "equals" },
            enabled: { value: null, matchMode: "equals" },
        },
    });

    const enableds = [
        { label: t("enabled", { ns: "common" }), value: "Y" },
        { label: t("disabled", { ns: "common" }), value: "N" },
    ];

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        findEducations(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                    e.priority = i + 1;
                });
                setEducations(dataRes);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => {
                setLoading(false);
            });
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const checkboxBodyTemplate = (rowData) => {
        return (
            <>
                <div className="flex align-items-center justify-content-center">
                    <Checkbox checked={rowData.enabled === "Y"} readOnly />
                </div>
            </>
        );
    };

    const textFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <InputText value={options.value} onChange={(e) => options.filterApplyCallback(e.target?.value || "")} />
            </div>
        );
    };

    const checkboxFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />
            </div>
        );
    };

    const numberFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <InputText type="number" value={options.value} onChange={(e) => options.filterApplyCallback(e.target?.value || 0)} />
            </div>
        );
    };

    const searchOption = (
        <div className="grid">
            {/* mã */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "66px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="code"
                    >
                        {t("education.code")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="code"
                            name="code"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        code: {
                                            ...lazyParams.filters.code,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* tên */}
            <div className="col-12 md:col-4">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "66px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="name"
                    >
                        {t("education.name")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="name"
                            name="name"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        name: {
                                            ...lazyParams.filters.name,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* Hiệu lực */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "86px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="nationalityAcron"
                    >
                        {t("education.enabled")}
                    </label>
                    <Dropdown
                        value={lazyParams?.filters?.enabled?.value}
                        className="col"
                        style={{
                            width: "100%",
                            margin: "5px 0px 0px 0px ",
                            // width: "calc(100% -100px)",
                        }}
                        showClear={true}
                        id="enabled"
                        name="enabled"
                        options={enableds}
                        onChange={(e) => {
                            setCheckLoad(false);
                            setLazyParams({
                                ...lazyParams,
                                filters: {
                                    ...lazyParams.filters,
                                    enabled: {
                                        ...lazyParams.filters.enabled,
                                        value: e.value,
                                    },
                                },
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>

            <div className="col-12 md:col-1 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                setCheckLoad(true);
                                setLazyParams({
                                    ...lazyParams,
                                    first: 0,
                                    page: 0,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };
    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("education.title")?.toUpperCase()}</h4>
                        </div>
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                        <div className="col-12">
                            <BlockDetail title={t("education.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={educations}
                                    dataKey="id"
                                    className="datatable-responsive p-datatable-sm"
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="code" header={t("education.code")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="name" header={t("education.name")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="description" header={t("education.description")} sortable filter showFilterMatchModes={false} filterElement={textFilterTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="priority" header={t("education.priority")} sortable filter showFilterMatchModes={false} filterElement={numberFilterTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column
                                        field="enabled"
                                        header={t("education.enabled")}
                                        dataType="boolean"
                                        sortable
                                        filter
                                        filterElement={checkboxFilterTemplate}
                                        body={checkboxBodyTemplate}
                                        headerStyle={{ width: "10rem" }}
                                        style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }}
                                    />
                                </DataTable>
                            </BlockDetail>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
